(function () {
  'use strict';

  var configElement = document.getElementById('rh-offer-config');
  if (!configElement) return;
  var config = JSON.parse(configElement.textContent);
  var marked = new URLSearchParams(window.location.search).get('offer') === 'rh15';

  function eligibleProduct(url) {
    if (url.origin !== window.location.origin) return false;
    var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    return match && config.handles.indexOf(match[1]) !== -1;
  }

  function offerLink(value) {
    var url = new URL(value, window.location.origin);
    if (url.pathname === '/discount/RHPRODUCTION15') {
      var redirect = new URL(url.searchParams.get('redirect') || '/', url.origin);
      if (!eligibleProduct(redirect)) return value;
      redirect.searchParams.set('offer', 'rh15');
      url.searchParams.set('redirect', redirect.pathname + redirect.search);
      return url.pathname + url.search;
    }
    if (!eligibleProduct(url)) return value;
    url.searchParams.set('offer', 'rh15');
    return '/discount/RHPRODUCTION15?redirect=' + encodeURIComponent(url.pathname + url.search);
  }

  var root = document.getElementById('rh-page') || document.getElementById('maincontent');
  function updateLinks() {
    root.querySelectorAll('a[href], [data-href]').forEach(function (element) {
      var attribute = element.hasAttribute('data-href') ? 'data-href' : 'href';
      var original = element.getAttribute(attribute);
      var updated = offerLink(original);
      if (updated !== original) element.setAttribute(attribute, updated);
    });
  }

  if (!config.landing && !marked) return;
  updateLinks();
  // Related product cards can be rendered after the main product view starts.
  new MutationObserver(updateLinks).observe(root, { childList: true, subtree: true });

  if (config.landing) return;
  var ProductOptions = require('product_options_selection_view');
  var regularFormatter = ProductOptions.prototype.priceFormatter;
  ProductOptions.prototype.priceFormatter = function (variant) {
    if (!variant || config.handles.indexOf(this.product.handle) === -1) {
      return regularFormatter.call(this, variant);
    }
    return Helpers.formatMoney(Math.round(variant.price * 85 / 100));
  };

  var price = document.querySelector('.product-options-selector .product-price');
  if (price) {
    var note = document.createElement('p');
    note.className = 'rh-offer-note secondary-description theta serif grey italic';
    note.textContent = 'Your 15% production discount is already applied.';
    price.insertAdjacentElement('afterend', note);
  }
}());
